var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 9C0.875 4.5125 4.5125 0.875 9 0.875C13.4875 0.875 17.125 4.5125 17.125 9C17.125 13.4875 13.4875 17.125 9 17.125C4.5125 17.125 0.875 13.4875 0.875 9ZM8.13 7.79833C9.085 7.32083 10.1608 8.18417 9.90167 9.22L9.31083 11.5833L9.34583 11.5667C9.49268 11.5021 9.65873 11.4965 9.8096 11.551C9.96048 11.6054 10.0846 11.7158 10.1564 11.8593C10.2281 12.0028 10.2419 12.1684 10.195 12.3217C10.148 12.4751 10.0439 12.6046 9.90417 12.6833L9.87083 12.7017C8.915 13.1792 7.83917 12.3158 8.09833 11.28L8.69 8.91667L8.655 8.93333C8.58128 8.9743 8.50003 8.99993 8.41615 9.00867C8.33226 9.01741 8.24748 9.00908 8.1669 8.98418C8.08632 8.95928 8.01161 8.91834 7.94727 8.86381C7.88294 8.80927 7.8303 8.74229 7.79254 8.66687C7.75478 8.59146 7.73267 8.50919 7.72754 8.425C7.72242 8.34082 7.73439 8.25647 7.76272 8.17704C7.79106 8.0976 7.83518 8.02472 7.89243 7.96279C7.94968 7.90086 8.01887 7.85115 8.09583 7.81667L8.13 7.79833ZM9 6.5C9.16576 6.5 9.32473 6.43415 9.44194 6.31694C9.55915 6.19973 9.625 6.04076 9.625 5.875C9.625 5.70924 9.55915 5.55027 9.44194 5.43306C9.32473 5.31585 9.16576 5.25 9 5.25C8.83424 5.25 8.67527 5.31585 8.55806 5.43306C8.44085 5.55027 8.375 5.70924 8.375 5.875C8.375 6.04076 8.44085 6.19973 8.55806 6.31694C8.67527 6.43415 8.83424 6.5 9 6.5Z",
    fill: "#FFAC06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.6453676500cb26cddaf1e153604b6d48.svg";
export { ForwardRef as ReactComponent };